class BarracudaCart{
    constructor(opener, target, cartPage){
        this.debug = false;
        if(opener && target){
            this.opener = opener;
            this.target = target;
            this.counterContainer = this.opener.querySelector(".count-container");
            this.counter = this.opener.querySelector(".count")
            this.timer = null
            this.cartPage = cartPage;

            console.log("Cart page:",this.cartPage);
            this.init();
            if(this.cartPage)
                this.initButtonsInLines();
        }else{
            console.error("Barracuda Cart need opener and target element")
        }
    }
    init(){
        /* when click on cart opener, refresh content */
        this.opener.addEventListener("click",this.refreshCart.bind(this));

        /* find all addToCart buttons on page and change them to ajax */
        document.querySelectorAll(".barracuda-cart-addToCartButton").forEach(button=>{
            this.appendAddToCartButton(button);
        })

    }
    appendAddToCartButton(element){
        element? element.addEventListener("click",this.addToCart.bind(this)): false;
    }
    initButtonsInLines(){
        // all buttons in cart topbar
        this.target.querySelectorAll(".barracuda-cart-removeButton").forEach(button=>{
            button.addEventListener("click",this.removeFromCart.bind(this));
        })
        this.target.querySelectorAll(".barracuda-cart-quantityInput").forEach(input=>{
            new BarracudaCount(input);
            input.addEventListener("change",this.setQuantityCart.bind(this));
        })

        // and all buttons in cart page (if exists)
        if(this.cartPage){
            this.cartPage.querySelectorAll(".barracuda-cart-removeButton").forEach(button=>{
                button.addEventListener("click",this.removeFromCart.bind(this));
            })
            this.cartPage.querySelectorAll(".barracuda-cart-quantityInput").forEach(input=>{
                new BarracudaCount(input);
                input.addEventListener("change",this.setQuantityCart.bind(this));
            })
        }

        Barracuda.init(); // init collapsible
    }
    getCart(){
      //  this.target.classList.add("loading");
      var x = this.target.classList;
      x.add("loading");
        axios.get('/cart.js')
        .then(function (response) {
            x.remove("loading");

          //var hasItem = false;
          // csJq(response.data.items).each(function(index,val){
          //   if(val.handle == "keshar-shrikhand"){
          //     hasItem = true;
          //   }
          // });
          
          window.setMaxDays = undefined;
          for(var i=0; i < response.data.items.length ; i++) {
            if(response.data.items[i].handle=="keshar-shrikhand") {
              window.setMaxDays = 5;
            }
          }
          console.log(window.setMaxDays, 'ssss', response.data.items)
          // if(hasItem == true){
          //   window.setMaxDays = 5;
          // }else{
          //   window.setMaxDays = undefined;
          // }
          
          if(response.data['item_count']) this.refreshCartIcon(response.data['item_count'])
          else this.refreshCartIcon(0);
          
        }.bind(this))
        .catch(function (error) {
            x.remove("loading");
            console.error(error);
        });
    }
    refreshCartIcon(count = null){
      if(count != null){
        axios.get('/cart?section_id=cart-count')
        .then(function (response) {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(response.data, 'text/html');
          document.querySelector('.barracuda-cart-opener .count').innerHTML = htmlDoc.querySelector('.count').innerHTML;
          if (htmlDoc.querySelector('.count-container').classList.contains('hide') 
              ? document.querySelector('.barracuda-cart-opener .count-container').classList.add('hide') 
              : document.querySelector('.barracuda-cart-opener .count-container').classList.remove('hide'));
        });
        var opener = this.opener;
      } else {
          this.getCart();
      }
    }
refreshCart(){
    axios.get('/cart?sections=main-cart')
    .then(function (response) {
        console.log('response', response)
        var code = response.data ? (response.data["main-cart"] ? response.data["main-cart"] : false) : false;
        if (code){
            this.target.innerHTML = code;
            this.target.classList.remove("hide");
            if(this.cartPage){
                this.cartPage.innerHTML = code;
                if(this.cartPage.classList[5] == 'first-of-type'){
                    if(typeof MainCode != "undefined") {
                        if(window.jQuery) {
                            csJq = window.jQuery;
                        }
                        MainCode(csJq);
                    }
                } 
            }
            this.initButtonsInLines();
        }
    }.bind(this))
    .catch(function (error) {
        console.error(error);
    });
}

    getNumber() {
      var minNumber = 100000;
      var maxNumber = 900000;
      var randomnumber = Math.floor(Math.random() * (maxNumber - minNumber + 1) + minNumber);
      return randomnumber;
    }
    addLabourAndHamperBoxToAllItems(allItems, count, bundle_id, mainproductProperties) {
      const labourProduct = window.additionalHamperCost.extraCostProducts.labour, 
            hamperBoxProduct = window.additionalHamperCost.extraCostProducts.hamper_box;
      if (window.additionalHamperCost.extraCostProducts.labour != null) {
        allItems.push({
          id: labourProduct.id,
          quantity: count,
          properties: {
            '_main_product': window.additionalHamperCost.mainProduct,
            'hamperId': bundle_id
          }
        });
        mainproductProperties['_labour'] = Shopify.formatMoney(labourProduct.price);
      }
      if (window.additionalHamperCost.extraCostProducts.hamper_box != null) {
        allItems.push({
          id: hamperBoxProduct.id,
          quantity: count,
          properties: {
            '_main_product': window.additionalHamperCost.mainProduct,
            'hamperId': bundle_id
          }
        });
        mainproductProperties['_box_packing'] = Shopify.formatMoney(hamperBoxProduct.price);
      }
    }
    addBufferToAllItems(allItems, count, bundle_id, mainproductProperties) {
      if (window.additionalHamperCost.bufferRate == null && window.additionalHamperCost.extraCostProducts.buffer == null) return;

      const bufferProduct = window.additionalHamperCost.extraCostProducts.buffer, 
            bufferPrice = (window.hamperfinalPrice * window.additionalHamperCost.bufferRate/100);
      window.hamperfinalPrice = window.hamperfinalPrice + bufferPrice;

      allItems.push({
        id: bufferProduct.id,
        quantity: count * Math.ceil(bufferPrice / 100),
        properties: {
          '_main_product': window.additionalHamperCost.mainProduct,
          'hamperId': bundle_id,
          '_buffer_product' : 'Yes'
        }
      });
      mainproductProperties['_buffer_rate'] = window.additionalHamperCost.bufferRate + '%';
    }
    addGSTToAllItems(allItems, count, bundle_id, mainproductProperties) {
      if (window.additionalHamperCost.gstRate == null && window.additionalHamperCost.extraCostProducts.gst == null) return;

      const gstProduct = window.additionalHamperCost.extraCostProducts.gst, 
            gstPrice = Math.ceil((window.hamperfinalPrice * window.additionalHamperCost.gstRate/100) / 100);

      allItems.push({
        id: gstProduct.id,
        quantity: count * gstPrice,
        properties: {
          '_main_product': window.additionalHamperCost.mainProduct,
          'hamperId': bundle_id,
          '_gst_product' : 'Yes'
        }
      });
      mainproductProperties['GST Rate'] = window.additionalHamperCost.gstRate + '%';
    }
    addToCart(e, item = null, count = 1, plans = null){
        if(this.timer){
            clearTimeout(this.timer);
        }
        var form = e.target.closest("form");
        form.classList.add("adding-to-cart");

        if(item==null) item = parseInt(form.querySelector("select[name=id]").value)
        if(form.querySelector("input[name=quantity]")) count = parseInt(form.querySelector("input[name=quantity]").value)
        if(form.querySelector("select[name=selling_plan]")) plans = parseInt(form.querySelector("select[name=selling_plan").value);

        var maxCount = null
        if(form.querySelector("select[name=id]") && form.querySelector("select[name=id] option[selected]").dataset.max) {
            maxCount = parseInt(form.querySelector("select[name=id] option[selected]").dataset.max)
        }

      var bundleItems = document.querySelectorAll('.bundle-item'), 
          bundle_id = this.getNumber(), 
          customOption = false,
          allItems = [], mainproductProperties = {};

       bundleItems.forEach((item, index) => {
        var variantSelect = item.querySelector('.bundle_variants');
        if (variantSelect) {
          var properties = {
            '_main_product': window.additionalHamperCost.mainProduct,
            'hamperId': bundle_id
          };
          var selectedOption = variantSelect.options[variantSelect.selectedIndex];
          var option_name = variantSelect.getAttribute('data-option-name'),
              dataId = parseInt(selectedOption.getAttribute('data-id')), 
              main_product = selectedOption.getAttribute('data-main-product'),
              custom_product = selectedOption.getAttribute('data-custom-product');
          if (!isNaN(dataId) && dataId !== null && dataId !== undefined) {
              allItems.push({
                  id: dataId,
                  quantity: count,
                  properties: properties
              });
              customOption = true;
              mainproductProperties[`${option_name}`] = custom_product;
            }
          }
       }); 
        if (customOption) {
          if (window.additionalHamperCost != undefined) {
            this.addLabourAndHamperBoxToAllItems(allItems, count, bundle_id, mainproductProperties);
            this.addBufferToAllItems(allItems, count, bundle_id, mainproductProperties);
            this.addGSTToAllItems(allItems, count, bundle_id, mainproductProperties);
          }
          mainproductProperties['hamperId'] = bundle_id
          allItems.push({
              id: item,
              quantity: count,
              properties: mainproductProperties
          });
          console.log(allItems,'mainproduct');
        } else {
          allItems.push({
              id: item,
              quantity: count
          });
        }
      
        prevent(e);
        if((maxCount == null || maxCount < 0 || count <= maxCount)) {
            if(!form.dataset.sellingPlan){
              prevent(e);
              if (this.debug) console.log("Barracuda Cart - addToCart", item, count, plans, "event: ", e);
              let data = {
                "items": allItems
              };
              console.log(data,'jsonObject')
                if (plans != null && plans!=""){
                    data.items[0].selling_plan = plans
                }    
    
                axios.post('/cart/add.js',data)
                .then(function (response) {
                    if (this.debug) console.log("Barracuda Cart - added to cart", response);
                    this.refreshCartIcon()
                    this.animateCartIcon()
                    if(this.cartPage) this.refreshCart();
                    form.classList.remove("adding-to-cart");
                    form.classList.add("added-to-cart");

                    var targetProduct = form.closest(".product-form");
                    if(targetProduct && targetProduct.querySelector(".cant-add-more")){
                        targetProduct.querySelector(".cant-add-more").classList.add("visually-hidden");
                    }
                    if(targetProduct && targetProduct.querySelector(".cant-add-other")){
                        targetProduct.querySelector(".cant-add-other").classList.add("visually-hidden");
                    }

                    unlockBodyPosition();
                    document.querySelector("body").classList.remove("show-overlay");
                }.bind(this))
                .catch(function (error) {
                    form.classList.remove("adding-to-cart");
                    form.classList.add("error-when-adding-to-cart");
                    console.error(error);
                    var targetProduct = form.closest(".product-form");
                    if(error.response.status = "422" && targetProduct && targetProduct.querySelector(".cant-add-other span.message")){
                        targetProduct.querySelector(".cant-add-other span.message").innerHTML = error.response.data.description;
                        targetProduct.querySelector(".cant-add-other").classList.remove("visually-hidden");
                        setTimeout(function(){
                            targetProduct.querySelector(".cant-add-other").classList.add("visually-hidden");
                        },5000);
                    }
                });
            }
        } else {
            prevent(e);
            var targetProduct = form.closest(".product-form");
            if(targetProduct && targetProduct.querySelector(".cant-add-more")){
                targetProduct.querySelector(".cant-add-more").classList.remove("visually-hidden");
                this.timer = setTimeout(function(){
                    targetProduct.querySelector(".cant-add-more").classList.add("visually-hidden");
                    if(form.querySelector("input[name=quantity]")) form.querySelector("input[name=quantity]").value = maxCount;
                },5000);
            }
            form.classList.remove("adding-to-cart");
            form.classList.add("error-when-adding-to-cart");
        }
        
    }
  
    removeFromCart(e){
        prevent(e)
        this.setQuantityCart(e, null, 0);
    }

    getAllLineItem(e, id, quantity) {
      var qtyArray = [];
      console.log(e.target, 'e.target');
      if (e.target.closest(".item-line").dataset.bundleId !== null) {
        const bundleId = e.target.closest(".item-line").dataset.bundleId;
        const form = e.target.closest('[action="/cart"]');
      
        if (form) {
          form.querySelectorAll('.item-line').forEach((ele, i) => {
            if (ele.dataset.bundleId && ele.dataset.bundleId === bundleId) {
              if (ele.dataset.gst == 'Yes' || ele.dataset.buffer == 'Yes'){
                qtyArray.push(parseInt(ele.querySelector('[name="updates[]"]').value) * parseInt(quantity));
              } else {
                qtyArray.push(quantity);
              }
            } else if (ele.dataset.id === id) {
              qtyArray.push(quantity);
            } else {
              const inputValue = parseInt(ele.querySelector('[name="updates[]"]').value);
              qtyArray.push(inputValue);
            }
          });
        }
      }
      return qtyArray;
    }
  
    setQuantityCart(e, id= null, quantity = null){
        if(this.timer){
            clearTimeout(this.timer);
        }

        if(id == null) id = e.target.closest(".item-line").dataset.id;
        if(quantity == null) quantity = e.target.closest("input").value;
        var maxCount = null, qtyArray = [];
      
        if(e.target.closest("input") && e.target.closest("input").dataset.max){
            maxCount = parseInt(e.target.closest("input").dataset.max);
        }
      
        if(maxCount == null || maxCount < 0 || quantity <= maxCount){
            /* create fade for item-line in cart, when user remove last item from line. */ 
            if(quantity == 0){
                var line = e.target.closest(".item-line")
                line.style.height = line.scrollHeight + "px";
              line.classList.add("item-line-removed");
                setTimeout(()=>{
                    line.style.height = "0px";
                },10);
            }

            
            qtyArray = this.getAllLineItem(e, id, quantity);
            console.log('Cart Items changed: ', qtyArray);
          
            prevent(e)
            setTimeout(()=>{
                var data = {'updates' : {}};
                // data['updates'][id] = quantity;
                  data['updates'] = qtyArray;
                  axios.post('/cart/update.js',data)
                    .then(function (response) {
                        this.refreshCart();
                        this.refreshCartIcon();
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    });
            },400);
        }else{
            console.warn("You can't add more then "+maxCount+" item/items to the cart.");
            var cantAdd =  e.target.closest(".item-line").querySelector(".cant-add-more")
            if(cantAdd){
                cantAdd.classList.remove("visually-hidden");
            }

            qtyArray = this.getAllLineItem(e, id, maxCount);
            console.log('Cart Items changed: ', qtyArray);
            this.timer = setTimeout(function(){
                setTimeout(()=>{
                    e.target.closest("input").value = maxCount;
                    var data = {'updates' : {}};
                    // data['updates'][id] = maxCount;
                      data['updates'] = qtyArray;
                        axios.post('/cart/update.js',data)
                        .then(function (response) {
                            this.refreshCart();
                            this.refreshCartIcon();
                        }.bind(this))
                        .catch(function (error) {
                            console.error(error);
                        });
                },400);
            }.bind(this),5000);
        }
    }
    animateCartIcon(){
      document.querySelector("body").classList.remove("scroll-down")
      document.querySelector("body").classList.add("scroll-top")
      this.counterContainer.classList.remove("animate");
      setTimeout(()=>{
        this.counterContainer.classList.add("animate");
      },5)
    }
}